import { useEffect, useState } from 'react'
import { Paper, Grid, makeStyles, Container } from '@material-ui/core'
import { scroller } from 'react-scroll'
import TextCollapseSp from '../ui/TextCollapseSp'
import ButtonSp from '../ui/ButtonSp'
import ApplyForm from './ApplyForm'
import Axios from 'axios'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles(theme => ({
  positionsOuter: {
    ...theme.homeStyle.section,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    }
  },
  title: {
    ...theme.homeStyle.title,
  },
  tabPaper: {
    width: '90%',
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    cursor: 'pointer',
    textAlign: 'left',
    '& h4': {
      margin: '0 !important',
      fontSize: 22,
    },
    '& h5': {
      margin: 0,
      fontSize: 16,
      color: '#828282',
    },
  },
  active: {
    '& h4': {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  careerDetails: {
    textAlign: 'left',
    padding: theme.spacing(2),
    '& h3': {
      fontSize: 32,
      marginTop: 0,
      textAlign: 'left',
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    }
  },
  positionDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    '& h5': {
      margin: 0,
      fontSize: 18,
    },
  },
  button: {
    ...theme.homeStyle.button,
    alignSelf: 'center',
  },
}))

const Positions = ({ isMobile, isTablet }) => {

  const [activeTab, setActiveTab] = useState(null)
  const [selectedPosition, setPosition] = useState(null)
  const [positionsData, setPositionsData] = useState(null)
  const [positionChoices, setPositionChoices] = useState([])
  const classes = useStyles()

  const { t } = useTranslation('career')

  useEffect(() => {
    Axios.get('/api/career/positions')
    .then((res) => {
      setPositionsData(res.data)
      setActiveTab(Object.keys(res.data)[0])
      let choices = []
      Object.entries(res.data).map( ([groupName,groupObj]) => {
        choices.push(...Object.keys(groupObj))
      } )
      setPositionChoices(choices)
    })
    .catch((err) => {
      setPositionsData(null)
    })
  },[])


  const scrollToForm = () => {
    scroller.scrollTo('apply-form',{smooth:'easeInOutQuart',offset:-300})
  }

  const handleButtonClick = (positionName) => {
    // collapse all
    setPosition(positionName)
    scrollToForm()
  }

  const TabPaper = ({ title, amount }) => {

    const isActive = (activeTab === title)

    return (
      <Paper
        className={clsx(classes.tabPaper,isActive && classes.active)}
        elevation={isActive ? 3 : 0}
        onClick={()=>setActiveTab(title)}
      >
        <h4>{title}</h4>
        <h5>{amount} {t('positions')}</h5>
      </Paper>
    )
  }

  const CareerDetails = () => {

    if (typeof positionsData !== 'object' || !activeTab ) return (
      <div className={classes.careerDetails}>
        <h3>{t('not-found')}</h3>
      </div>
    )

    let textCollapseData = []

    Object.entries(positionsData[activeTab]).map( ([positionName,{res,req,amount}]) => {
      const detailJsx = (
        <div className={classes.positionDetails}>
          <h5>{t('responsibilities')}</h5>
          <ul>
            { res.map( (singleRes) => (
              <li key={singleRes}>{singleRes}</li>
            ) ) }
          </ul>
          <h5>{t('requirements')}</h5>
          <ul>
            { req.map( (singleReq) => (
              <li key={singleReq}>{singleReq}</li>
            ) )}
          </ul>         
          <ButtonSp className={classes.button} onClick={()=>handleButtonClick(positionName)}>{t('apply')}</ButtonSp>
          
        </div>
      )
      
      textCollapseData.push({
        title: positionName,
        desc: detailJsx,
        subtitle: `${amount} ${t('positions')}`
      })
    } )
    
    return (
      <div className={classes.careerDetails}>
        <h3>{activeTab}</h3>
        <TextCollapseSp data={textCollapseData} />
      </div>
    )
  }

  const renderTabs = () => {
    if (typeof positionsData === 'object' && positionsData !== null) {
      return Object.entries(positionsData).map( ([groupName,positions]) => {
        let totalAmount = 0
        Object.entries(positions).forEach( ([_,dataObj]) => {
          totalAmount += dataObj.amount
        } )
        return (
          <TabPaper title={groupName} amount={totalAmount} key={groupName} />
        )
      })
    } else {
      return <TabPaper title={'ไม่พบข้อมูล'} amount={0} />
    }
  }

  return (
    <>
    <div
      className={classes.positionsOuter}
    >
      <h2 className={classes.title}>{t('job-openings')}</h2>
      <Container>
      <Grid container direction="row">
        <Grid
          item
          xs={12}
          sm={3}
          container
          direction="column"
        >
          {
            renderTabs()
          }
        </Grid>
        <Grid
          item
          xs={12}
          sm={9}
          container
          direction="column"
        >
          {CareerDetails()}
        </Grid>
      </Grid>
      </Container>
    </div>
      <ApplyForm selectedPosition={selectedPosition} positions={positionChoices} id="apply-form" />
    </>
  )
}

export default Positions
